export const HOUSEHOLD_PROFILE = "HouseholdProfile";
export const CONTACT_PROFILE = "ContactProfile";
